import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";

import axios from "axios";
import envConfig from "../../bin/env.config";
import { useSelector } from "react-redux";
import VizSensor from "react-visibility-sensor";
import CompanyLogo from "../Common/CompanyLogo";
import ProductImageByCompanyProductId from "../Common/ProductImageByCompanyProductId";
import SearchBox from "./SearchBox";
import CompanyDropDownBox from "./CompanyDropDownBox";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from "@material-ui/core/IconButton";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
  title: {
    flexGrow: 1,
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
  },
  searchInput: {
    flexGrow: 1,
    marginRight: theme.spacing(2),
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "200px",
  },
  noResults: {
    textAlign: "center",
    padding: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
  table: {
    minWidth: 350,
    "& tbody>.MuiTableRow-root:hover": {
      background: "#DDD",
    },
  },
  potentialProductImage: {
    width: 50,
    height: 50,
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      width: 25,
      height: 25,
    },
  },
}));

export function RowItem(props) {
  const classes = useStyles();
  const { product, onSelect, row_number } = props;
  const [isVisible, setIsVisible] = useState(false);

  const doLoadData = (isVisibleChanged) => {
    isVisibleChanged && setIsVisible(isVisibleChanged);
  };
  const handleCreateAndMatch = (product)=>{
    // history.push(`/possible-existing/${product.productID}`);
    window.open(`/possible-existing/${product.id}`);
  } 
  return (
    <VizSensor onChange={doLoadData}>
      <TableRow>
        {!isVisible ? (
          <TableCell align="left" colSpan={8}>
            <CircularProgress size={16} />
          </TableCell>
        ) : (
          <>
            <TableCell align="left">{row_number + 1}</TableCell>
            <TableCell align="left">
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleCreateAndMatch(product)}
              >
                Create Group
              </Button>
            </TableCell>
            <TableCell align="left">{product.id}</TableCell>
            <TableCell>
                <ProductImageByCompanyProductId company_product_id={product.company_product_id} className={classes.potentialProductImage}/>
              {/* <img
                className={classes.potentialProductImage}
                src={product.image_url}
                alt={product.name}
              /> */}
            </TableCell>
            <TableCell align="left">{product.fullname}</TableCell>
            <TableCell align="left">{product.size}</TableCell>
            <TableCell align="left">{product.brand}</TableCell>
            <TableCell align="center">
              <CompanyLogo
                company_id={product.company_id}
                style={{ height: "50px" }}
              />
            </TableCell>
          </>
        )}
      </TableRow>
    </VizSensor>
  );
}

export default function CreateNewGroupPage() {
  const classes = useStyles();
  const history = useHistory();
  const companies = useSelector(state => state.companies.companies);
  const token = useSelector(state => state.session.token);
  const selectedCompany = companies&&companies.find(company=>company.selected);
  
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [products, setProducts] = useState([]);
  const [limit, setLimit] = useState(20);
  const [skip, setSkip] = useState(0);
  const [searchType, setSearchType] = useState(2);

  useEffect(() => {
    if (searchText || selectedCompany) {
      fetchProducts();
    }
  }, [searchText, selectedCompany, skip, limit, searchType]);

 

  const fetchProducts = async () => {
    setIsLoading(true);
    try {
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/matching/products/without-groups`;
      const params = {
        q: searchText,
        companyId: selectedCompany?selectedCompany._id:0,
        limit:limit,
        skip:skip,
        searchType:searchType,
      };
      
      const response = await axios.post(url, params, {
        headers: {
          Authorization: token,
        },
      });
      
      if (skip === 0) {
        setProducts(response.data.data);
      } else {        
        setProducts([...products, ...response.data.data]);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (value) => {
    setSearchText(value);
    setSkip(0);
  };

  const handleLoadMore = () => {
    let newSkip = skip + limit;
    setSkip(newSkip);
  };

  const handleCreateGroup = (product) => {
    history.push(`/product-matching/create-group/${product._id}`);
  };

  const handleSearchTypeChange = (event) => {
    setSearchType(event.target.value);
    setSkip(0);
  };

  return (
    <div className={classes.root}>
      <AppBar position="sticky" color="inherit">
        <Toolbar>
        <IconButton
            color="inherit"
            onClick={() => history.goBack()}
            aria-label="Close"
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography className={classes.title} variant="h6" noWrap>
            Create New Product Group
          </Typography>
          <div style={{ flexGrow: 1 }} />
          <Select value={searchType} onChange={handleSearchTypeChange}>
            <MenuItem value="2">
              <em>PostgreSQL Similar</em>
            </MenuItem>
            <MenuItem value="4">
              <em>PostgreSQL ilike</em>
            </MenuItem>
            <MenuItem value="5">
              <em>PostgreSQL ilike Attributes</em>
            </MenuItem>
            <MenuItem value="6">
              <em>PostgreSQL ts_vector</em>
            </MenuItem>
          </Select>
          <CompanyDropDownBox />
          <SearchBox 
            doSearch={handleSearch} 
            placeholder="Search products to create a new group" 
            value={searchText}
            searchOnChange={false} 
            style={{width: "500px"}}
          />
        </Toolbar>
      </AppBar>

      <div className={classes.content}>
        {isLoading ? (
          <div className={classes.loadingContainer}>
            <CircularProgress />
          </div>
        ) : products.length === 0 ? (
          <div className={classes.noResults}>
            No products found. Try adjusting your search criteria.
          </div>
        ) : (
          <TableContainer component={Paper} >
            <Table className={classes.table} stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="left">#</TableCell>
                  <TableCell align="left">Action</TableCell>
                  <TableCell align="left">Product ID</TableCell>
                  <TableCell align="left">Image</TableCell>
                  <TableCell align="left">Name</TableCell>
                  <TableCell align="left">Size</TableCell>
                  <TableCell align="left">Brand</TableCell>
                  <TableCell align="center">Company</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {products.map((product, index) => (
                  <RowItem
                    key={product._id}
                    product={product}
                    onSelect={handleCreateGroup}
                    row_number={index}
                  />
                ))}
                {products.length >= limit && (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleLoadMore}
                      >
                        Load More
                      </Button>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
    </div>
  );
}
